import { Banner, Box, H1, Text } from '@betterment/samba-react';

import { UploadCsvValidationErrorType } from '../data';

interface UploadCsvValidationErrorBannerProps {
  errorType: UploadCsvValidationErrorType;
}

export const UploadCsvValidationErrorBanner = ({ errorType }: UploadCsvValidationErrorBannerProps) => {
  const renderErrorContent = () => {
    switch (errorType) {
      case UploadCsvValidationErrorType.MissingHeaders:
        return <Text as="p">The header in the uploaded CSV does not match the template.</Text>;

      case UploadCsvValidationErrorType.TooManyRows:
        return (
          <Text as="p">
            Uploaded CSV exceeds maximum row limit of 500. Make sure to delete rows for accounts you won't bill.
          </Text>
        );

      case UploadCsvValidationErrorType.InvalidFileFormat:
        return <Text as="p">The file you selected is not in CSV format.</Text>;

      case UploadCsvValidationErrorType.TooManyContentFailures:
        return (
          <>
            <H1 variant="title100" css={{ mb: 'space.200' }}>
              100+ issues found in your upload
            </H1>
            <Text as="p" css={{ mb: 'space.200' }}>
              Please re-upload and try again. Common issues include:
            </Text>
            <Box css={{ pl: 'space.300' }}>
              <ul style={{ listStyleType: 'disc', margin: 0 }}>
                <li>Invalid account number</li>
                <li>Insufficient balance in client account</li>
                <li>Fee amount over $1M</li>
                <li>Missing values</li>
              </ul>
            </Box>
          </>
        );

      case UploadCsvValidationErrorType.NoFeeAmounts:
        return <Text as="p">The uploaded CSV does not have any fee amount.</Text>;

      case UploadCsvValidationErrorType.GenericError:
        return <Text as="p">An error occurred while uploading your CSV. Please try again.</Text>;

      default:
        throw new Error(`Unhandled error type: ${String(errorType)}`);
    }
  };

  return (
    <Banner variant="critical" css={{ width: '100%' }}>
      <Banner.Content>{renderErrorContent()}</Banner.Content>
    </Banner>
  );
};
